import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/maintenance/')({
  beforeLoad: ({ context }): void => {
    // Land on the FIRST tab the viewer may actually see. General (service plans) needs
    // `service-plans:list`; everyone who cleared the parent guard has `service-operations:list`, so
    // Service operations is the safe fallback. Until permissions resolve, go to General optimistically —
    // its own guard bounces a viewer without `service-plans:list` to Service operations once ready.
    const { hasPermission, isReady } = context.permissions;
    const target =
      !isReady || hasPermission('service-plans:list')
        ? '/settings/maintenance/general'
        : '/settings/maintenance/service-operations';
    throw redirect({ to: target });
  },
});
